import { Button, Card, CardBody, Col, Form, Row } from "reactstrap";
import { EmiTitle, FirstName, LastName, PinCode, Submit } from "../../../../constants";
import { dynamicImage } from "../../../../utils";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";
import { EmiBankSelect, EmiCardSelect, EmiYearSelect } from "../../../../data/applications/ECommerce";
import FormInput from "./common/FormInput";
import SelectInput from "./common/SelectInput";
import { Image } from "../../../../coreComponents/Image";

// This component is used to create a form for EMI (Equated Monthly Installment) payment details, with fields for customer details and payment method selections.
const Emi = () => {
  return (
    <Col xxl="4" lg="6" className="box-col-6">
      <Card>
        <CommonCardHeader title={EmiTitle} headClass="pb-0" />
        <CardBody>
          <Form className="theme-form" onSubmit={(e) => e.preventDefault()}>
            <Row>
              <FormInput type="text" placeholder={FirstName} formClass="col-6 p-r-0" />
              <FormInput type="text" placeholder={LastName} formClass="col-6" />
              <FormInput type="text" placeholder={PinCode} formClass="col-6 p-r-0" />
              <SelectInput size={1} data={EmiBankSelect} selectClass="col-6" />
              <SelectInput size={1} data={EmiCardSelect} selectClass="col-12" />
              <SelectInput size={1} data={EmiYearSelect} selectClass="col-12" />
              <Col xs="12" className="mb-3">
                <ul className="payment-opt">
                  <li>
                    <Image src={dynamicImage(`ecommerce/mastercard.png`)} />
                  </li>
                  <li>
                    <Image src={dynamicImage(`ecommerce/visa.png`)} />
                  </li>
                  <li>
                    <Image src={dynamicImage(`ecommerce/paypal.png`)} />
                  </li>
                </ul>
              </Col>
              <Col xs="12">
                <Button color="primary">{Submit}</Button>
              </Col>
            </Row>
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
};
export default Emi;
